import React from 'react';
import styled from 'styled-components';
import {getCategoriesTrail} from "../../reducers/categoriestrail";
import {getMessage} from "../../reducers/i18n";
import {connect} from 'react-redux';
import InternalLink from '../InternalLink';

const CategoriesTrail = ( {trail, title, ...props} ) => {

    const StyledThing = styled.div`
        font-size: 0.9em;
        display: flex;
        flex-wrap: nowrap;
        flex-direction: row;
        
        & .stolo-breadcrumb-item-spacer {
          color: ${props => props.theme.palette.blueGrey[300]};
          padding: 0 ${props => props.theme.space[4]};
        }
    `;

    const length = trail.length;

    if ( length > 0 ) {
        const items = trail.map( ( location, index ) => {
                if ( index < length - 1 ) {
                    return (
                        <div className="stolo-breadcrumb-item" key={index}>
                            <InternalLink
                                to={{type: location.type, payload: location.payload}}
                                {...props}

                            >
                                {location.title || title}
                            </InternalLink>
                            <span className="stolo-breadcrumb-item-spacer">&raquo;</span>
                        </div>

                    );
                }
                // This the last element in the trail. We don't want this to
                // be a link
                return (
                    <div className="stolo-breadcrumb-item" key={index}>{location.title}</div>
                )
            }
        );

        return (
            <StyledThing>
                {items}
            </StyledThing>
        );
    }
    return null
};

const mapStateToProps = ( state ) => {
    return {
        trail: getCategoriesTrail( state ),
        title: getMessage( state, "TOPCATEGORIES" )
    }
};

export default connect( mapStateToProps )( CategoriesTrail );



// WEBPACK FOOTER //
// ./src/components/categories/CategoriesTrail.js